import React from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';

import animation from '../assets/animations/Loading.json';

const Container = styled.section`
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100%;
  z-index: 10000;
  background: white;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;

  .load-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
  }

  .loader {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 33px;
  }

  .loader div {
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #5a5a5a;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  .loader div:nth-child(1) {
    left: 10px;
    animation: flip1 0.6s infinite;
  }

  .loader div:nth-child(2) {
    left: 10px;
    animation: flip2 0.6s infinite;
  }

  .loader div:nth-child(3) {
    left: 32px;
    animation: flip2 0.6s infinite;
  }

  .loader div:nth-child(4) {
    left: 56px;
    animation: flip3 0.6s infinite;
  }

  @keyframes flip1 {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes flip3 {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0);
    }
  }

  @keyframes flip2 {
    0% {
      transform: translate(0, 0);
    }

    100% {
      transform: translate(24px, 0);
    }
  }
`;

const LoadingInitial = () => {
  return (
    <Container>
      <Lottie className="loading-page" animationData={animation} loop={true} />
      <div className='load-container'>
        <strong
          style={{
            marginTop: '-40px',
            fontSize: 30,
            color: '#5a5a5a',
            fontStyle: 'italic',
          }}
        >
          Loading
        </strong>
        <div className="loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </Container>
  );
};

export default LoadingInitial;
